export const HOURS_IN_DAY = 24;
export const MINUTES_IN_DAY = HOURS_IN_DAY * 60;
export const SECONDS_IN_DAY = MINUTES_IN_DAY * 60;
export const MILLISECONDS_IN_DAY = SECONDS_IN_DAY * 1000;
